import React, { useState, useCallback } from "react";
import TextareaAutosize from "react-textarea-autosize";
import {
  Button,
  Modal,
  Header,
  Icon,
  Radio,
  Segment,
  Form,
  Message
} from "semantic-ui-react";

/**
 * 묶음 도서 일괄 상태 변경 모달.
 *  - REQUEST 상태인 책들 → 승인/반려/취소 일괄 적용
 *  - APPROVAL 상태인 책들 → 수령 일괄 적용
 *  - 백엔드가 transition 가능한 row 만 update 하므로 mixed status 묶음도 안전
 */
const BatchActionModal = ({ onClose, onSubmit, bookCount, hasRequest, hasApproval }) => {
  // 기본 선택: 처리 가능한 첫 옵션으로
  const defaultStatus = hasRequest ? "APPROVAL" : hasApproval ? "RECEIPT" : "APPROVAL";
  const [status, setStatus] = useState(defaultStatus);
  const [rejectReason, setRejectReason] = useState("");

  const onRadioChange = useCallback((e, { value }) => {
    setStatus(value);
  }, []);

  const submit = useCallback(() => {
    onSubmit(status, status === "REJECT" ? rejectReason : null);
  }, [onSubmit, status, rejectReason]);

  return (
    <Modal closeIcon open={true} onClose={onClose} size="small">
      <Header icon="cogs" content={`묶음 일괄 처리 (총 ${bookCount}권)`} />
      <Modal.Content>
        <Message size="small">
          <p>
            선택한 상태에 맞는 책만 처리됩니다. (예: '수령'은 승인된 책에만 적용,
            '승인/반려/취소'는 신청 상태인 책에만 적용)
          </p>
        </Message>
        <Segment.Group>
          <Segment>
            <Form>
              <Form.Field>
                <Radio
                  label={`일괄 승인${!hasRequest ? " (신청 상태 책 없음)" : ""}`}
                  name="batchStatusGroup"
                  value="APPROVAL"
                  checked={status === "APPROVAL"}
                  onChange={onRadioChange}
                  disabled={!hasRequest}
                />
              </Form.Field>
              <Form.Field>
                <Radio
                  label={`일괄 반려${!hasRequest ? " (신청 상태 책 없음)" : ""}`}
                  name="batchStatusGroup"
                  value="REJECT"
                  checked={status === "REJECT"}
                  onChange={onRadioChange}
                  disabled={!hasRequest}
                />
              </Form.Field>
              <Form.Field>
                <Radio
                  label={`일괄 수령등록${!hasApproval ? " (승인 상태 책 없음)" : ""}`}
                  name="batchStatusGroup"
                  value="RECEIPT"
                  checked={status === "RECEIPT"}
                  onChange={onRadioChange}
                  disabled={!hasApproval}
                />
              </Form.Field>
            </Form>
          </Segment>
          <Segment>
            <Form>
              <Form.Field
                control={TextareaAutosize}
                placeholder="반려 사유 (반려 선택 시 필수)"
                value={rejectReason}
                onChange={e => setRejectReason(e.target.value)}
                disabled={status !== "REJECT"}
                minRows={2}
              />
            </Form>
          </Segment>
        </Segment.Group>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose}>취소</Button>
        <Button
          color="green"
          onClick={submit}
          disabled={
            (status === "REJECT" && !rejectReason.trim()) ||
            ((status === "APPROVAL" || status === "REJECT") && !hasRequest) ||
            (status === "RECEIPT" && !hasApproval)
          }
        >
          <Icon name="checkmark" /> 일괄 처리
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default BatchActionModal;
